import { BuildingPermitStage } from '../../types/BuildingPermitStage';

export default function getStageFromTorontoPermit(
  torontoBuildingPermitObject: any,
): BuildingPermitStage {
  const { STATUS, ISSUED_DATE, COMPLETED_DATE } = torontoBuildingPermitObject;

  if (STATUS === 'Cancelled') {
    return BuildingPermitStage.Cancelled;
  } else if (ISSUED_DATE && COMPLETED_DATE) {
    return BuildingPermitStage.Completed;
  } else if (ISSUED_DATE) {
    return BuildingPermitStage.Issued;
  } else {
    return BuildingPermitStage.Applied;
  }
}
